import { StripeCardElementOptions } from "@stripe/stripe-js";

const cardOptions: StripeCardElementOptions = {
  iconStyle: "solid",
  style: {
    base: {
      fontSize: "16px",
      lineHeight: "1.5",
      "::placeholder": {
        fontSize: "14px",
      },
    },
    invalid: {
      color: "red",
    },
  },
};
export default cardOptions;
